import { createAction } from 'Helpers';
import businessTypes from './types';

const businessActions = {
	getCategoriesRequest: createAction(businessTypes.CATEGORIES.REQUEST),
	getCategoriesSuccess: createAction(businessTypes.CATEGORIES.SUCCESS),
	getCategoriesFailure: createAction(businessTypes.CATEGORIES.FAILURE),
	clearCategories: createAction(businessTypes.CATEGORIES.CLEAR),

	getBusinessRequest: createAction(businessTypes.GET_BUSINESS.REQUEST),
	getBusinessSuccess: createAction(businessTypes.GET_BUSINESS.SUCCESS),
	getBusinessFailure: createAction(businessTypes.GET_BUSINESS.FAILURE),
	getBusinessClear: createAction(businessTypes.GET_BUSINESS.CLEAR),

	getBusinessListRequest: createAction(businessTypes.GET_BUSINESS_List.REQUEST),
	getBusinessListSuccess: createAction(businessTypes.GET_BUSINESS_List.SUCCESS),
	getBusinessListFailure: createAction(businessTypes.GET_BUSINESS_List.FAILURE),
	getBusinessListClear: createAction(businessTypes.GET_BUSINESS_List.CLEAR),

	getBusinessItemRequest: createAction(businessTypes.BUSINESSITEM.REQUEST),
	getBusinessItemSuccess: createAction(businessTypes.BUSINESSITEM.SUCCESS),
	getBusinessItemFailure: createAction(businessTypes.BUSINESSITEM.FAILURE),
	clearBusinessItem: createAction(businessTypes.BUSINESSITEM.CLEAR),

	getRateAndReviewRequest: createAction(businessTypes.RATEANDREVIEW.REQUEST),
	getRateAndReviewSuccess: createAction(businessTypes.RATEANDREVIEW.SUCCESS),
	getRateAndReviewFailure: createAction(businessTypes.RATEANDREVIEW.FAILURE),
	clearRateAndReview: createAction(businessTypes.RATEANDREVIEW.CLEAR),

	getBusinessCommisionRequest: createAction(
		businessTypes.BUSINCOMMISION.REQUEST
	),
	getBusinessCommisionSuccess: createAction(
		businessTypes.BUSINCOMMISION.SUCCESS
	),
	getBusinessCommisionFailure: createAction(
		businessTypes.BUSINCOMMISION.FAILURE
	),
	clearBusinessCommision: createAction(businessTypes.BUSINCOMMISION.CLEAR),

	updateBusinessRequest: createAction(businessTypes.UPDATE.REQUEST),
	updateBusinessSuccess: createAction(businessTypes.UPDATE.SUCCESS),
	updateBusinessFailure: createAction(businessTypes.UPDATE.FAILURE),
	updateBusinessClear: createAction(businessTypes.UPDATE.CLEAR),

	businessPackesRequest: createAction(businessTypes.PACKAGES.REQUEST),
	businessPackesSuccess: createAction(businessTypes.PACKAGES.SUCCESS),
	businessPackesFailure: createAction(businessTypes.PACKAGES.FAILURE),
	businessPackesClear: createAction(businessTypes.PACKAGES.CLEAR),

	businessSignRequest: createAction(businessTypes.SIGN.REQUEST),
	businessSignSuccess: createAction(businessTypes.SIGN.SUCCESS),
	businessSignFailure: createAction(businessTypes.SIGN.FAILURE),
	businessSignClear: createAction(businessTypes.SIGN.CLEAR),

	businessCreateRequest: createAction(businessTypes.CREATE_BUSINESS.REQUEST),
	businessCreateSuccess: createAction(businessTypes.CREATE_BUSINESS.SUCCESS),
	businessCreateFailure: createAction(businessTypes.CREATE_BUSINESS.FAILURE),
	businessCreateClear: createAction(businessTypes.CREATE_BUSINESS.CLEAR),

	businessSuperBusinessRequest: createAction(
		businessTypes.SUPER_BUSINESS.REQUEST
	),
	businessSuperBusinessSuccess: createAction(
		businessTypes.SUPER_BUSINESS.SUCCESS
	),
	businessSuperBusinessFailure: createAction(
		businessTypes.SUPER_BUSINESS.FAILURE
	),
	businessSuperBusinessClear: createAction(businessTypes.SUPER_BUSINESS.CLEAR),

	businessContractLinkRequest: createAction(
		businessTypes.CONTRACT_LINK.REQUEST
	),
	businessContractLinkSuccess: createAction(
		businessTypes.CONTRACT_LINK.SUCCESS
	),
	businessContractLinkFailure: createAction(
		businessTypes.CONTRACT_LINK.FAILURE
	),
	businessContractLinkClear: createAction(businessTypes.CONTRACT_LINK.CLEAR),

	businessContractInfoLinkRequest: createAction(
		businessTypes.CONTRACT_BUSINESS_INFO.REQUEST
	),
	businessContractInfoLinkSuccess: createAction(
		businessTypes.CONTRACT_BUSINESS_INFO.SUCCESS
	),
	businessContractInfoLinkFailure: createAction(
		businessTypes.CONTRACT_BUSINESS_INFO.FAILURE
	),
	businessContractInfoLinkClear: createAction(
		businessTypes.CONTRACT_BUSINESS_INFO.CLEAR
	),

	getCashierMachinesRequest: createAction(
		businessTypes.GET_CASHIER_MACHINES.REQUEST
	),
	getCashierMachinesSuccess: createAction(
		businessTypes.GET_CASHIER_MACHINES.SUCCESS
	),
	getCashierMachinesFailure: createAction(
		businessTypes.GET_CASHIER_MACHINES.FAILURE
	),
};

export default businessActions;
